export default "__VITE_ASSET__D3u2Zu6L__"